import { useEffect, useState } from "react";
import { checkAllEmpty, removeEmpty } from "../../../utils/utilities";

function getValues(options) {
  const empty = checkAllEmpty(options, "url");
  if (empty) return false;
  return removeEmpty(options, "url");
}

function useAvailableOptions() {
  const [options, setOptions] = useState(false);

  useEffect(() => {
    const allOptions = [
      { url: process.env.REACT_APP_SNOW, text: "Service Now" },
    ];
    setOptions(getValues(allOptions));
  }, []);
  return options;
}

export default useAvailableOptions;
